"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSubmissionType = void 0;
var DocumentSubmissionType;
(function (DocumentSubmissionType) {
    DocumentSubmissionType["NEW"] = "NEW";
    DocumentSubmissionType["AUTO_SYNC"] = "AUTO_SYNC";
    DocumentSubmissionType["SAVE_DRAFT"] = "SAVE_DRAFT";
    DocumentSubmissionType["SUBMIT"] = "SUBMIT";
    DocumentSubmissionType["ADD_PARTICIPANT"] = "ADD_PARTICIPANT";
    DocumentSubmissionType["DELETE"] = "DELETE";
})(DocumentSubmissionType = exports.DocumentSubmissionType || (exports.DocumentSubmissionType = {}));
//# sourceMappingURL=documentSubmissionType.js.map